import React from 'react';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, IconButton, TablePagination, Box } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

type Hardware = {
      id: number;
      oui?: string;
      hclass?: string;
      DisplayName: string;
      manufacturer?: string;
      version?: string;
      protocol?: string;
};

interface Props {
  columns: { key: string; label: string }[];
  visibleColumns: Record<string, boolean>;
  rows: Hardware[];
  page: number;
  rowsPerPage: number;
  count: number;
  onEdit: (r: Hardware) => void;
  onDelete: (id: number) => void;
  onChangePage: (_: unknown, page: number) => void;
  onChangeRowsPerPage: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function HardwareTable({ columns, visibleColumns, rows, page, rowsPerPage, count, onEdit, onDelete, onChangePage, onChangeRowsPerPage }: Props) {
  return (
    <Box>
      <TableContainer sx={{ maxHeight: '58vh' }}>
        <Table size="medium">
          <TableHead>
            <TableRow sx={{ backgroundColor: '#1e1e1e' }}>
              {columns.map((c) => (visibleColumns[c.key] ? <TableCell key={c.key} sx={{ color: '#cfcfcf' }}>{c.label}</TableCell> : null))}
              <TableCell sx={{ color: '#cfcfcf' }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((r) => (
              <TableRow key={r.id} hover sx={{ borderBottom: '1px solid rgba(255,255,255,0.03)', height: 64 }}>
                {columns.map((c) => (visibleColumns[c.key] ? <TableCell key={c.key} sx={{ color: '#ddd', fontSize: 14 }}>{(r as any)[c.key] ?? ''}</TableCell> : null))}
                <TableCell>
                  <IconButton size="small" onClick={() => onEdit(r)}>
                    <EditIcon fontSize="small" />
                  </IconButton>
                  <IconButton size="small" onClick={() => onDelete(r.id)}>
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        component="div"
        count={count}
        page={page}
        onPageChange={onChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={onChangeRowsPerPage}
        rowsPerPageOptions={[5, 10, 20]}
        sx={{ color: '#bdbdbd' }}
      />
    </Box>
  );
}
